<template>
<main>
    <div class="fa G_DisplayColumnNowrap G_BorderRadius L_AlertHolder">
        <div class="G_DisplayRowNowrap G_HeadingFont">
            <span class="L_AlertHeading">{{ AlertDescription }}</span>
        </div>
    </div>
</main>
</template>

<script>
export default {
    props: [
        "ShopItem",
        "AlertDescription"
    ],
    data() {
        return {

        }
    },
    methods: {}
}
</script>

<style lang="scss">
@import "../../assets/GlobalCss.scss";

.L_AlertHolder {
    width: 30rem;
    height: 5rem;
    position: fixed;
    top: 7%;
    left: 50%;
    transform: rotate(0deg) translate(-50%, -50%);
    box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.75);
    background-color: #F3CBBB;
    justify-content: center;
    align-items: center;

    @include mobile() {
        width: 25rem;
    }
}

.L_AlertHeading {
    color: #FFFFFF;
}
</style>
